export default __webpack_public_path__ + "static/media/shield1.eb6cf9d7.png";